module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "c-hsm-game-link u-relative u-block u-flex__item--auto u-flex--x",
    attrs: {
      "href": _vm.href
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm._onClick($event)
      }
    }
  }, [_c('div', {
    staticClass: "c-hsm-game-link__bg--1 u-absolute u-pos-tl u-fit"
  }), _vm._v(" "), _c('div', {
    staticClass: "c-hsm-game-link__bg--2 u-absolute u-pos-tl u-fit"
  }), _vm._v(" "), _c('span', {
    staticClass: "c-hsm-game-link__text u-block u-flex__item--center u-marg-auto "
  }, [_c('span', {
    staticClass: "c-hsm-game-link__text--over t-lspacing--xl u-absolute u-color--white u-uppercase",
    class: [_vm.spanClass]
  }, [_vm._t("default")], 2), _vm._v(" "), (_vm.$slots.default.length > 0) ? _c('span', {
    staticClass: "t-lspacing--xl u-color--red-pure u-uppercase",
    class: [_vm.spanClass],
    domProps: {
      "innerHTML": _vm._s(_vm.$slots.default[0].text)
    }
  }) : _vm._e()])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-637e366c"}!./src/scripts/components/app-hsm-link/template.html
// module id = 928
// module chunks = 0